// ── 8bitbrain Email Popup ──
// Form submits natively to Shopify /contact (form 'customer' tag),
// Shopify redirects back with ?customer_posted=true and form.posted_successfully? = true,
// which sets window.__popupSubscribeSuccess in the liquid. This script reacts to it.

document.addEventListener('DOMContentLoaded', async function() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (!popup) return;

  // ── Case 1: user just subscribed successfully (redirected back from Shopify) ──
  if (window.__popupSubscribeSuccess) {
    popup.classList.add('open');
    if (overlay) overlay.classList.add('open');
    sessionStorage.setItem('8bb_popup_done', '1');

    // If freepack mode · add the free product to cart
    if (window.__popupSubscribeMode === 'freepack') {
      var variantId = window.__popupSubscribeVariant;
      if (variantId && variantId !== '0' && variantId !== 0) {
        try {
          if (typeof window.addToCart === 'function') {
            // Goes through the cart queue: never adds a pack that is already in the bag, quantity stays 1.
            window.addToCart(parseInt(variantId, 10), null);
          } else {
            var cur = await (await fetch('/cart.js')).json();
            var vid = parseInt(variantId, 10);
            var have = (cur.items || []).some(function(it) { return it.variant_id === vid; });
            if (!have) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: vid, quantity: 1 })
              });
            }
            if (typeof refreshCart === 'function') {
              refreshCart();
            }
          }
        } catch (e) {
          console.log('[popup] Free pack add to cart failed:', e);
        }
      }
    }

    // Clean ?customer_posted=true from URL so refresh does not keep it
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        var clean = url.pathname + (url.search || '') + url.hash;
        window.history.replaceState({}, document.title, clean);
      }
    } catch (e) {}
    return;
  }

  // ── Case 2: Shopify returned form errors (email invalid / already taken) · keep popup open ──
  if (window.__popupSubscribeError) {
    popup.classList.add('open');
    if (overlay) overlay.classList.add('open');
    return;
  }

  // ── Case 3: already shown this session · show corner badge only ──
  if (sessionStorage.getItem('8bb_popup_done')) {
    if (corner) corner.style.display = 'block';
    return;
  }

  // ── Case 4: normal flow · show popup after delay ──
  var delay = (parseInt(popup.dataset.delay, 10) || 5) * 1000;
  function openWhenCalm() {
    // Never cover a Buy Now redirect or a cart drawer the visitor just opened.
    var drawer = document.getElementById('cart-drawer');
    if ((typeof bbLeaving !== 'undefined' && bbLeaving) || (drawer && drawer.classList.contains('open'))) {
      setTimeout(openWhenCalm, 3000);
      return;
    }
    popup.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }
  setTimeout(openWhenCalm, delay);
});

function closePopup() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (popup) popup.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  if (corner) corner.style.display = 'block';
  sessionStorage.setItem('8bb_popup_done', '1');
}

function reopenPopup() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (popup) popup.classList.add('open');
  if (overlay) overlay.classList.add('open');
  if (corner) corner.style.display = 'none';
}

function copyCode(el) {
  var code = el.dataset.code;
  var copySpan = el.querySelector('.code-copy');
  navigator.clipboard.writeText(code).then(function() {
    if (copySpan) {
      copySpan.textContent = 'COPIED!';
      setTimeout(function() { copySpan.textContent = 'COPY'; }, 2000);
    }
  }).catch(function() {});
}